import { ReadBreakOffsets, useGetBreakOffsetsQuery } from '../gql/graphql.generated';

export const useGetBreakOffsets = () => {
  const [offsetData] = useGetBreakOffsetsQuery();

  return offsetData?.data?.breakOffsets as ReadBreakOffsets;
};
